import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=55a16632&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"
import style0 from "./AllRequests.vue?vue&type=style&index=0&id=55a16632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports